import { useContext } from 'react';
import { ReportContext } from 'assets/js/pages/reports/ReportContext';
import { useQueryDiff } from 'assets/js/pages/reports/useQueryDiff';
import { getInitialState } from 'assets/js/pages/reports/util';
import * as DropdownMenu from 'components/dropdown-menu';
import { transformPartitionedSavedFilters } from 'components/filter/filters-next/downstream';
import { TableContext } from 'components/table/TableContext';
import { useTableReset } from 'components/table/TableReset';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { useCurrentReport } from 'customHooks/useCurrentReport';
import { useTableSchema } from 'customHooks/useTableSchema';

const ResetReportStateDropdownItem = () => {
    const { data: report } = useCurrentReport();
    const { data } = useTableSchema(report.resource);
    const initialReportState = getInitialState(report, data);
    const {
        setChartColumn,
        setChartType,
        setSortColumn,
        setSortDirection,
        setDateRange,
        setDateRangeType,
    } = useContext(ReportContext);
    const { table } = useContext(TableContext);
    const { reset } = useTableReset(table);
    const updateFilters = useFiltersCache(state => state.updateFiltersNextByKey);
    const hasDiff = useQueryDiff();

    return (
        <DropdownMenu.Item
            disabled={!hasDiff}
            onClick={() => {
                setDateRange(initialReportState.dateRange);
                setDateRangeType(initialReportState.dateRangeType);
                setChartColumn(initialReportState.chartColumn);
                setChartType(initialReportState.chartType);
                setSortDirection(initialReportState.sortDirection);
                setSortColumn(initialReportState.sortColumn);
                updateFilters(
                    'singleReport',
                    transformPartitionedSavedFilters(report.query.filters),
                );
                reset();
            }}
        >
            Reset to report defaults
        </DropdownMenu.Item>
    );
};

export { ResetReportStateDropdownItem };
